import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Layout, Menu, Button, Row, Col, Typography, Form, Input } from "antd";

import signinbg from "../assets/cms/cms-signin-picture.png";
import logo from "../assets/images/logo.png";

const { Title } = Typography;
const { Header, Footer, Content } = Layout;

const SignIn = () => {
  const history = useHistory();

  const [errorMessage, setErrorMessage] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [currentUserRole, setCurrentUserRole] = useState(null);

  const getCurrentUser = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingData(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL+ "user/getCurrentUser",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log("current user:", response);
      setCurrentUserRole(response?.data?.roles[0]);
      response?.data?.roles[0] !== "ROLE_ADMIN"
        ? setErrorMessage(true)
        : setErrorMessage(false);

      setLoadingData(false);
      if (response?.data?.roles[0] === "ROLE_ADMIN") {
        history.push("/dashboard");
      } else {
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   localStorage.removeItem("token");
  // }, []);

  const onFinish = async (values) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL+ "user/login",
        {
          username: values.username,
          password: values.password,
        }
      );
      console.log("response: ", response);
      if (response.data.success === true) {
        setErrorMessage(false);
        console.log(response.data.reason);
        localStorage.setItem("token", response.data.reason);
        getCurrentUser();
      } else {
        console.log(response.data.reason);
        setErrorMessage(true);
      }
    } catch (e) {
      console.log("error:", e.response.data.reason);
      setErrorMessage(true);
      console.log(e);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Layout className="layout-default layout-signin">
        <Header>
          <div
            style={{ display: "flex", flexDirection: "row" }}
            className="header-col header-brand"
          >
            <img src={logo} style={{ height: "60px" }} />
            <h5>C M S</h5>
          </div>
          <div className="header-col header-nav"></div>
        </Header>
        <Content className="signin">
          <Row gutter={[24, 0]} justify="space-around">
            <Col
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 2 }}
              md={{ span: 12 }}
            >
              <Title className="mb-15">Sign In</Title>
              <Title className="font-regular text-muted" level={5}>
                Enter your username and password to sign in
              </Title>
              <Form
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                className="row-col"
              >
                <Form.Item
                  className="username"
                  label="Username"
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Please input your username!",
                    },
                  ]}
                >
                  <Input placeholder="Username" />
                </Form.Item>

                <Form.Item
                  className="username"
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                >
                  <Input type="password" placeholder="Password" />
                </Form.Item>

                {errorMessage ? (
                  <p style={{ color: "#ff4d4f" }}>
                    Error! Possible invalid credentials!
                  </p>
                ) : null}

                <Form.Item>
                  {/*<Link to="/dashboard">*/}
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                  >
                    SIGN IN
                  </Button>
                  {/*</Link>*/}
                </Form.Item>
              </Form>
            </Col>
            <Col
              className="sign-img"
              style={{ padding: 12 }}
              xs={{ span: 24 }}
              lg={{ span: 12 }}
              md={{ span: 12 }}
            >
              <img src={signinbg} alt="" />
            </Col>
          </Row>
        </Content>
        <Footer>
          <Menu mode="horizontal" className="menu-nav-social"></Menu>
          <p
            style={{ marginTop: "200px", marginBottom: "50px" }}
            className="copyright"
          >
            {" "}
            Copyright © 2023 Central Monitoring System{" "}
          </p>
        </Footer>
      </Layout>
    </>
  );
};

export default SignIn;
